export default __webpack_public_path__ + "static/1044-7b51f08c9457304abd8ad827b8323382.gif";